import { PermissionsRequiredRightsByEntity } from '../types';

import { CRM_PERMISSIONS_REQUIRED_RIGHTS } from './crm-permissions-required-rights';
import { DMS_PERMISSIONS_REQUIRED_RIGHTS } from './dms-permissions-required-rights';
import { ERP_PERMISSIONS_REQUIRED_RIGHTS } from './erp-permissions-required-configs';
import { GENERAL_PERMISSIONS_REQUIRED_RIGHTS } from './general-permissions-required-rights';

export const PERMISSIONS_REQUIRED_RIGHTS_BY_ENTITY: PermissionsRequiredRightsByEntity =
  {
    ...CRM_PERMISSIONS_REQUIRED_RIGHTS,
    ...DMS_PERMISSIONS_REQUIRED_RIGHTS,
    ...ERP_PERMISSIONS_REQUIRED_RIGHTS,
    ...GENERAL_PERMISSIONS_REQUIRED_RIGHTS,
  };
